module.exports = __webpack_public_path__ + "img/write-feedback.9b67fe84.svg";